import React from 'react';
import { useTranslation } from 'react-i18next';
import ContactButtons from './ContactButtons';
import useGreetingNames from '../useGreetingNames';

export default function GreetedContactButtons({ record, fill, greetingScript, ...contact }) {
  const { t } = useTranslation('common');
  const { names, error } = useGreetingNames(record, fill);
  return (
    <>
      <ContactButtons {...contact} greetingNames={names} greetingScript={greetingScript} />
      {error && <p className="crm-contact-status" role="alert">{t('crm.contact.greetingNameFailed', { error })}</p>}
    </>
  );
}
